import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { resetPreview, createModule, getCategories } from "../redux/customChartSagas";
import { MainModal } from "../../../components/modal/MainModal";
import PreviewContent from "./PreviewContent";
import { useError } from "../hooks/useError";
import { ErrorList } from "./ErrorList";

export const Add = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const selectedCategory = useSelector(
    (state) => state.customCharts.previewModalData.selectedCategories.category || {}
  );
  const close = () => {
    onClose();
    dispatch(resetPreview());
  };

  const { errors, status } = useError(close);
  const [name, setName] = useState("");

  const save = () => {
    dispatch(createModule({ name }));
  };

  const onInputChange = (name) => {
    setName(name);
  };

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  const primaryButtonDisabled = !(
    Object.keys(selectedCategory).length &&
    name &&
    name.trim() &&
    status !== "pending"
  );

  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".custom-charts"
      headerText="Add Custom Chart"
      headerCloseHandler={close}
      containerClassName="add-chart light"
      primaryButtonText="Save"
      primaryButtonDisabled={primaryButtonDisabled}
      primaryButtonClass="primary-btn"
      primaryBtnHandler={() => save()}
      secondaryBtnText="Cancel"
      secondaryBtnClass="secondary-btn"
      secondaryBtnHandler={close}
      height="auto"
      width={900}
    >
      <PreviewContent errors={errors} name={name} onInputChange={(name) => onInputChange(name)} />
      {status === "pending" && (
        <div className="preview-loader">
          <LoadingAnimation uiLoader />
        </div>
      )}
      <div className="popup__footer--error">
        <ErrorList errors={errors} />
      </div>
    </MainModal>
  );
};
